export const mediaContext = {
  images: '/content-service/api/external/userImages',
  imageById: '/content-service/api/external/userImages/{id}',
  externalImages: '/content-service/api/internal/httpImages',
  multipartImages: '/content-service/api/internal/multipartImage',
};
